// Block 8 — editorial public pages
const en = {
  err: { demo_preview_limit: "This part of the course is not included in the demo preview. Get full access to open it." },
  b6: { copyright: "© {{year}} Valeriia. All rights reserved." },
  b8: {
    operator: "Operator: {{name}}, {{address}} · Registration No. {{reg}} ({{jur}})",
    cta_title: "Start with a free look around",
    cta_sub: "Open the demo to see lessons, records and practical reviews as they really work — no registration needed.",
    start_learning: "Start learning",
    try_demo: "Try the demo — no registration",
    view_courses: "View the courses",
    the_method: "The methodology",
    about_author: "About the author",
    author_eyebrow: "Author of the method",
    portrait_alt: "Brand visual: a grooming comb and brush beside a resting dog",
    portrait_note: "Brand visual",
    career: "Career",
    credentials: "Credentials",
    teaches: "What she teaches",
    method_eyebrow: "The methodology",
    components: "Two components, one system",
    component_n: "Component {{n}}",
    directions: "Four practice directions",
    direction: "Direction {{k}}",
    related_course: "Related course",
    library: "Protocol library",
    audience: "Who it is for",
    boundaries: "Boundaries & referral",
    relation: "How it connects to the courses",
    learn_eyebrow: "Courses",
    how_title: "How learning works",
    step_lessons: "Lessons",
    step_check: "Knowledge check",
    step_sim: "Simulation",
    step_practical: "Practical reviewed by Valeriia",
    step_cert: "Certificate",
    for_all: "For every course",
    lessons_n_one: "{{count}} lesson",
    online: "Find Valeriia online",
    on_net: "{{name}} on {{net}}",
    new_tab: "opens in a new tab",
    lessons_n_other: "{{count}} lessons",
    inc_knowledge_check: "Knowledge check",
    inc_simulation: "Simulation",
    inc_practical: "Practical assignment",
    view_course: "View course",
    get_access: "Get access",
    cases_eyebrow: "Cases",
    read_case: "Read the case",
    illustrative_note: "Illustrative case: a teaching example, not a record of a real dog or a promise of results.",
    back_cases: "All cases",
    by: "Author",
    period: "Observation period",
    approach_links: "Directions",
    cat_eyebrow: "Catalogue",
    method_alt: "Close-up of a comb passing through a soft apricot coat",
    learning_alt: "Grooming tools laid out on linen",
    cases_alt: "A calm small dog resting on a grooming table",
    catalogue_alt: "Unlabelled care bottles and a wooden brush",
    cta_alt: "A dog's paw resting on folded linen beside a comb",
    sec_editor: "Page sections",
    add_item: "Add item",
    remove_item: "Remove",
    portrait_upload: "Upload portrait photo",
    portrait_remove: "Remove photo",
    portrait_set: "Photo uploaded — publish to show it",
    preview: "Full course — get access",
    one_per_line: "One item per line",
    preview_title: "Get full access",
    preview_text: "You are viewing the preview available in the demo: the course outline, the introduction and the first lesson. The rest of the course opens with full access.",
    preview_includes: "What the full course includes",
    preview_units: "Also in the course",
    see_pricing: "See pricing",
    create_account: "Create an account",
    other: "Other",
    f: { name: "Name", full_name: "Full name", title: "Professional title", lead: "Lead", timeline: "Career timeline", period: "Period", text: "Text", credentials: "Credentials", teaches: "What she teaches", portrait_alt: "Portrait alt text", links: "Profile links", kind: "Network", label: "Label", url: "URL (https://)", essence: "Essence", components: "Components", synergy: "Synergy note", audience: "Audience", boundaries: "Boundaries & referral", relation: "Relation to courses", directions: "Directions", key: "Direction letter", intro: "Intro" },
  },
};

const ru = {
  err: { demo_preview_limit: "Эта часть курса не входит в демо-фрагмент. Получите полный доступ, чтобы открыть её." },
  b6: { copyright: "© {{year}} Valeriia. Все права защищены." },
  b8: {
    operator: "Оператор: {{name}}, {{address}} · Рег. № {{reg}} ({{jur}})",
    cta_title: "Начните со знакомства",
    cta_sub: "Откройте демо, чтобы увидеть уроки, записи и проверку практических заданий так, как они работают, — без регистрации.",
    start_learning: "Начать обучение",
    try_demo: "Попробовать демо — без регистрации",
    view_courses: "Смотреть курсы",
    the_method: "О методике",
    about_author: "Об авторе",
    author_eyebrow: "Автор метода",
    portrait_alt: "Фирменный визуал: расчёска и щётка рядом с отдыхающей собакой",
    portrait_note: "Фирменный визуал",
    career: "Путь в профессии",
    credentials: "Квалификация",
    teaches: "Чему она учит",
    method_eyebrow: "Методика",
    components: "Два компонента — одна система",
    component_n: "Компонент {{n}}",
    directions: "Четыре направления практики",
    direction: "Направление {{k}}",
    related_course: "Курс по направлению",
    library: "Библиотека протоколов",
    audience: "Для кого",
    boundaries: "Границы и направление к ветеринару",
    relation: "Как это связано с курсами",
    learn_eyebrow: "Курсы",
    how_title: "Как проходит обучение",
    step_lessons: "Уроки",
    step_check: "Проверка знаний",
    step_sim: "Симуляция",
    step_practical: "Практическое задание с проверкой Валерии",
    step_cert: "Сертификат",
    for_all: "Для всех курсов",
    lessons_n_one: "{{count}} урок",
    online: "Валерия в сети",
    on_net: "{{name}} в {{net}}",
    new_tab: "откроется в новой вкладке",
    lessons_n_few: "{{count}} урока",
    lessons_n_many: "{{count}} уроков",
    lessons_n_other: "{{count}} урока",
    inc_knowledge_check: "Проверка знаний",
    inc_simulation: "Симуляция",
    inc_practical: "Практическое задание",
    view_course: "Открыть курс",
    get_access: "Получить доступ",
    cases_eyebrow: "Случаи",
    read_case: "Читать случай",
    illustrative_note: "Иллюстративный случай: учебный пример, а не запись о реальной собаке и не обещание результата.",
    back_cases: "Все случаи",
    by: "Автор",
    period: "Период наблюдения",
    approach_links: "Направления",
    cat_eyebrow: "Каталог",
    method_alt: "Крупный план: расчёска проходит сквозь мягкую абрикосовую шерсть",
    learning_alt: "Инструменты для груминга на льняной ткани",
    cases_alt: "Спокойная небольшая собака лежит на столе для груминга",
    catalogue_alt: "Флаконы без этикеток и деревянная щётка",
    cta_alt: "Лапа собаки на сложенном льне рядом с расчёской",
    sec_editor: "Разделы страницы",
    add_item: "Добавить",
    remove_item: "Удалить",
    portrait_upload: "Загрузить фото",
    portrait_remove: "Удалить фото",
    portrait_set: "Фото загружено — опубликуйте, чтобы показать",
    preview: "Полный курс — получить доступ",
    one_per_line: "По одному пункту в строке",
    preview_title: "Получите полный доступ",
    preview_text: "В демо доступен ознакомительный фрагмент: программа курса, введение и первый урок. Остальная часть курса открывается при полном доступе.",
    preview_includes: "Что входит в полный курс",
    preview_units: "Также в курсе",
    see_pricing: "Посмотреть цены",
    create_account: "Создать аккаунт",
    other: "Другое",
    f: { name: "Имя", full_name: "Полное имя", title: "Профессиональный титул", lead: "Вступление", timeline: "Хронология", period: "Период", text: "Текст", credentials: "Квалификация", teaches: "Чему она учит", portrait_alt: "Альтернативный текст фото", links: "Ссылки на профили", kind: "Сеть", label: "Подпись", url: "Адрес (https://)", essence: "Суть", components: "Компоненты", synergy: "Связь компонентов", audience: "Для кого", boundaries: "Границы и направление к ветеринару", relation: "Связь с курсами", directions: "Направления", key: "Буква направления", intro: "Вступление" },
  },
};

export default { en, ru };
